(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["geraete-finde"] && !Shopify.designMode) return;
  try {
    
/* Geräte-Finder – Gürteltier v2 */
(function () {
  var norm = function (s) { return (s || '').toLowerCase().replace(/\s+/g, ' ').trim(); };
  var skey = function (s) { return norm(String(s || '').replace(/[↔\/|,+&·()\[\]"]/g, ' ')); };
  var tight = function (s) { return skey(s).replace(/[\s\-.]/g, ''); };
  var esc = function (t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var ARROW = '<svg viewBox="0 0 8 8" aria-hidden="true"><path d="M2 1l3 3-3 3" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
  var cache = {}, pending = {};
  /* Speichern im Browser (localStorage) nur, wenn erlaubt:
     storeMode "off" = nie · "consent" = nur mit Einwilligung „Präferenzen“ (Shopify Customer Privacy API) · "always" = immer */
  var AV_KEY = 'hf-av-v1', AV_TTL = 12 * 3600 * 1000, saveT = null, storeMode = 'consent', loaded = false;
  function storageAllowed() {
    if (storeMode === 'off') return false;
    if (storeMode === 'always') return true;
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    try { return !!(cp && typeof cp.preferencesProcessingAllowed === 'function' && cp.preferencesProcessingAllowed()); } catch (e) { return false; }
  }
  function loadCache() {
    if (loaded || !storageAllowed()) return; loaded = true;
    try {
      var av = JSON.parse(localStorage.getItem(AV_KEY) || 'null');
      if (av && Date.now() - av.ts < AV_TTL) Object.keys(av.map || {}).forEach(function (k) { if (cache[k] === undefined) cache[k] = av.map[k]; });
    } catch (e) {}
  }
  function saveCache() {
    if (!storageAllowed()) return;
    clearTimeout(saveT);
    saveT = setTimeout(function () { try { localStorage.setItem(AV_KEY, JSON.stringify({ ts: Date.now(), map: cache })); } catch (e) {} }, 800);
  }
  function initConsent(onChange) {
    if (storeMode !== 'consent') { onChange(); return; }
    var S = window.Shopify;
    if (S && !S.customerPrivacy && typeof S.loadFeatures === 'function') {
      try { S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) onChange(); }); } catch (e) {}
    } else onChange();
    document.addEventListener('visitorConsentCollected', function () { onChange(); });
  }
  var queue = [], active = 0, MAXQ = 6;
  function pump() {
    while (active < MAXQ && queue.length) {
      var job = queue.shift(); active++;
      fetch(job.url + '/products.json?limit=1', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return !!(j.products && j.products.length); }, function () { return true; })
        .then((function (jb) { return function (ok) { cache[jb.url] = ok; saveCache(); active--; jb.done.forEach(function (f) { f(ok); }); pump(); }; })(job));
    }
  }
  function probe(url, high) {
    if (cache[url] !== undefined) return Promise.resolve(cache[url]);
    return new Promise(function (res) {
      var job = pending[url];
      if (job) { job.done.push(res); if (high && queue.indexOf(job) > 0) { queue.splice(queue.indexOf(job), 1); queue.unshift(job); } return; }
      job = pending[url] = { url: url, done: [res, function () { delete pending[url]; }] };
      high ? queue.unshift(job) : queue.push(job); pump();
    });
  }
  var BCOL = {};
  function parseBadgeColors(t) {
    BCOL = {};
    (t || '').split(/\n/).forEach(function (l) { var p = l.split('|').map(function (x) { return x.trim(); }); if (p[0] && p[1]) BCOL[p[0].toLowerCase()] = [p[1], p[2] || '#FFFFFF']; });
  }
  function badgeHTML(txt) {
    if (!txt) return '';
    var c = BCOL[String(txt).toLowerCase()];
    return '<span class="hf-bdg"' + (c ? ' style="--hf-bdg-bg:' + esc(c[0]) + ';--hf-bdg-fg:' + esc(c[1]) + '"' : '') + '>' + esc(txt) + '</span>';
  }
  var clean = function (u) { return String(u || '').replace(/[?#].*$/, '').replace(/\/$/, ''); };

  function parseRules(text) {
    var out = {};
    (text || '').split(/\n/).forEach(function (line) {
      var i = line.indexOf(':'); if (i < 0) return;
      var left = line.slice(0, i), j = left.indexOf('/'); if (j < 0) return;
      var brand = norm(left.slice(0, j)), name = left.slice(j + 1).trim();
      var kws = line.slice(i + 1).split(',').map(norm).filter(Boolean);
      if (!brand || !name || !kws.length) return;
      (out[brand] = out[brand] || []).push({ name: name, fallback: kws.indexOf('*') > -1, kws: kws.filter(function (k) { return k !== '*'; }) });
    });
    return out;
  }
  function parseCats(text) {
    return (text || '').split(/\n/).map(function (l) {
      var p = l.split('|').map(function (x) { return x.trim(); });
      if (!p[0] || !p[1]) return null;
      return { name: p[0], suf: p[1].split(',').map(function (s) { return s.trim(); }).filter(Boolean), sub: p[2] || '' };
    }).filter(Boolean);
  }
  function buildBrands(raw, rules, other) {
    var toM = function (m) { return { t: m[0], u: clean(m[1]), bd: m[2] || '' }; };
    var out = [];
    raw.forEach(function (b) {
      var groups = (b[2] || []).filter(function (g) { return g[1] && g[1].length; });
      if (!groups.length) {                         /* keine Modelle: als Link anzeigen */
        var u = clean(b[1]); if (u && u !== '') out.push({ name: b[0], link: b[1], bd: b[3] || '' }); return;
      }
      if (groups[0][0] !== null) { out.push({ name: b[0], bd: b[3] || '', series: groups.map(function (g) { return { name: g[0], models: g[1].map(toM) }; }) }); return; }
      var ms = groups[0][1].map(toM), r = rules[norm(b[0])];
      if (!r) { out.push({ name: b[0], bd: b[3] || '', series: null, models: ms }); return; }
      var buckets = r.map(function (s) { return { name: s.name, kws: s.kws, fallback: s.fallback, models: [] }; });
      var rest = { name: other, models: [] };
      ms.forEach(function (m) {
        var low = norm(m.t);
        var hit = buckets.filter(function (x) { return x.kws.some(function (k) { return low.indexOf(k) > -1; }); })[0]
          || buckets.filter(function (x) { return x.fallback; })[0] || rest;
        hit.models.push(m);
      });
      var ser = buckets.filter(function (x) { return x.models.length; });
      if (rest.models.length) ser.push(rest);
      out.push({ name: b[0], bd: b[3] || '', series: ser });
    });
    return out;
  }

  function init(host) {
    if (!host || host.__hf) return; host.__hf = true;
    var cfg = JSON.parse(host.querySelector('[data-hf-config]').textContent);
    storeMode = cfg.store || 'consent'; parseBadgeColors(cfg.badgeColors);
    /* ---- Analytics: dataLayer (GTM) und/oder Shopify Customer Events ----
       Jedes Event enthält immer alle Felder (null = leer), damit in GTM keine alten Werte „hängen bleiben“. */
    var KEYS = ['finder_type', 'finder_entry', 'finder_brand', 'finder_model', 'finder_category', 'finder_path', 'link_url',
                'search_term', 'results_count', 'depth_reached', 'open_source', 'close_reason', 'duration_ms'];
    function track(name, data) {
      var mode = cfg.analytics || 'datalayer'; if (mode === 'off') return;
      var p = {}; KEYS.forEach(function (k) { p[k] = data && data[k] !== undefined ? data[k] : null; });
      if (mode === 'datalayer' || mode === 'both') { window.dataLayer = window.dataLayer || []; var o = { event: name }; for (var k in p) o[k] = p[k]; window.dataLayer.push(o); }
      if (mode === 'shopify' || mode === 'both') { try { window.Shopify.analytics.publish(name, p); } catch (e) {} }
    }
    var sess = null;
    var raw = JSON.parse(host.querySelector('[data-hf-data]').textContent);
    var pEl = host.querySelector('[data-hf-panels]');
    var PAN = pEl ? JSON.parse(pEl.textContent).filter(function (p) { return p.columns && p.columns.length; }) : [];
    var T = cfg.t, id = host.getAttribute('data-id');
    var old = document.getElementById('hf-panel-' + id); if (old && !host.contains(old)) old.remove();

    var DEV = [];
    raw.forEach(function (d) {
      var brands = buildBrands(d.brands, cfg.group ? parseRules(d.rules) : {}, T.other);
      if (!brands.some(function (b) { return !b.link; })) return;
      DEV.push({ name: d.name, trigger: d.trigger, placeholder: d.placeholder, cats: parseCats(d.cats), brands: brands,
                 hasSeries: brands.some(function (b) { return b.series; }) });
    });
    if (!DEV.length && !PAN.length) { host.setAttribute('data-empty', ''); return; }
    var firstBd = function (list) { for (var i = 0; i < list.length; i++) if (list[i]) return list[i]; return ''; };
    DEV.forEach(function (d) {
      d.brands.forEach(function (b) {
        if (b.link) { b.inner = ''; return; }
        (b.series || []).forEach(function (sr) { sr.inner = firstBd(sr.models.map(function (m) { return m.bd; })); });
        b.inner = firstBd([b.bd].concat(b.series ? b.series.map(function (sr) { return sr.inner; }) : b.models.map(function (m) { return m.bd; })));
      });
      d.inner = firstBd(d.brands.map(function (b) { return b.bd || b.inner; }));
    });
    if (!DEV.length) DEV.push({ name: '', brands: [{ name: '', models: [] }], cats: [], hasSeries: false, empty: true });

    var flat = [];
    DEV.forEach(function (d, di) {
      d.brands.forEach(function (b, bi) {
        if (b.link) return;
        (b.series || [{ models: b.models }]).forEach(function (s, si) {
          s.models.forEach(function (m, mi) { var k = skey(b.name + ' ' + m.t); flat.push({ key: k, tk: tight(k), label: b.name + (DEV.length > 1 ? ' · ' + d.name : ''), m: m, d: di, b: bi, s: si, mi: mi }); });
        });
      });
    });

    var cats = [], seen = {};
    PAN.forEach(function (p) {
      p.columns.forEach(function (c) {
        c.links.forEach(function (l) {
          var u = l[1]; if (!u || seen[u + l[0]]) return; seen[u + l[0]] = 1;
          var k = skey(c.title + ' ' + l[0]), tt = skey(l[0]);
          cats.push({ key: k, tk: tight(k), tt: tt, ttk: tight(tt), title: l[0], bd: l[2] || '', label: norm(c.title) === norm(p.trigger) ? c.title : c.title + ' · ' + p.trigger, url: u });
        });
      });
    });
    var inline = cfg.mode === 'inline';
    var panel = document.createElement('div');
    panel.id = 'hf-panel-' + id;
    panel.className = 'hf-panel' + (inline ? ' hf-panel--inline' : '') + (cfg.shadow ? ' hf-panel--shadow' : '');
    panel.innerHTML = '<div class="hf-in">' +
      (inline ? '' : '<div class="hf-mhead"><span>' + esc(T.mobileTitle || cfg.mobileLabel) + '</span><button type="button" class="hf-x" aria-label="' + esc(T.close) + '">×</button></div>') +
      (cfg.search ? '<div class="hf-search"><svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="8.5" cy="8.5" r="6" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M13 13l5 5" stroke="currentColor" stroke-width="1.8"/></svg><input type="search" autocomplete="off"></div>' : '') +
      '<div class="hf-body"></div></div>';
    (inline ? host.querySelector('[data-hf-slot]') : document.body).appendChild(panel);
    var body = panel.querySelector('.hf-body'), q = panel.querySelector('input');
    var narrow = function () { return !window.matchMedia('(min-width:' + cfg.bp + 'px)').matches; };
    var multi = function () { return (DEV.length > 1 && (narrow() || inline)) || (narrow() && !inline && PAN.length > 0); };

    var st = { d: 0, b: 0, s: 0, m: -1, depth: 0 }, keep = 3, checkT;
    var dev = function () { return DEV[st.d]; };
    var firstBrand = function () { var i = 0; while (dev().brands[i] && dev().brands[i].link) i++; return i; };
    var brand = function () { return dev().brands[st.b]; };
    var models = function () { var b = brand(); return b.series ? b.series[st.s].models : b.models; };
    function setPlaceholder() { if (q) { q.placeholder = (st.depth === -1 ? T.placeholder : dev().placeholder) || T.placeholder; q.setAttribute('aria-label', q.placeholder); } }

    function upMark(txt) {                 /* Hinweis auf Neuheiten weiter unten im Baum */
      if (!txt || cfg.badgeUp === 'off') return '';
      return cfg.badgeUp === 'badge' ? badgeHTML(txt) : '<span class="hf-dot" aria-label="' + esc(txt) + '" title="' + esc(txt) + '"></span>';
    }
    function row(attr, i, on, label, right, own, inner) {
      return '<button type="button" class="hf-row' + (on ? ' is-on' : '') + '" ' + attr + '="' + i + '"><span>' + esc(label) + (own ? badgeHTML(own) : upMark(inner)) + '</span>' + right + '</button>';
    }
    function col(depth, cls, title, inner) {
      var back = depth > 0 || (depth === 0 && multi()) ? '<button type="button" class="hf-back" data-back="' + (depth - 1) + '">‹ ' + esc(T.back) + '</button>' : '';
      return '<div class="hf-col ' + cls + (st.depth === depth ? ' is-active' : '') + '" data-depth="' + depth + '">' + back + (title ? '<p class="hf-h">' + esc(title) + '</p>' : '') + inner + '</div>';
    }
    function catUrl(m, c) {
      if (!cfg.check) return m.u + c.suf[0];
      for (var i = 0; i < c.suf.length; i++) { var v = cache[m.u + c.suf[i]]; if (v === undefined) return null; if (v) return m.u + c.suf[i]; }
      return false;
    }
    function pickInner() {
      var back = '<button type="button" class="hf-back" data-back="2">‹ ' + esc(T.back) + '</button>';
      if (st.m < 0) return back + '<p class="hf-hint">' + esc(T.choose) + '</p>';
      var m = models()[st.m], links = '';
      var open = dev().cats.some(function (c) { return catUrl(m, c) === null; });
      if (open && !waited) {
        links = dev().cats.map(function () { return '<span class="hf-skel"></span>'; }).join('');
      } else dev().cats.forEach(function (c) {
        var u = catUrl(m, c); if (u === false) return;
        links += '<a class="hf-cat hf-in-anim" href="' + esc(u || m.u + c.suf[0]) + '"><span>' + esc(c.name) + (c.sub ? '<small>' + esc(c.sub) + '</small>' : '') + '</span>' + ARROW + '</a>';
      });
      links += '<a class="hf-cat hf-cat--all" href="' + esc(m.u) + '"><span>' + esc(T.all) + (T.allSub ? '<small>' + esc(T.allSub) + '</small>' : '') + '</span>' + ARROW + '</a>';
      return back + '<p class="hf-model">' + esc(m.t) + badgeHTML(m.bd) + '</p><p class="hf-q">' + esc(T.question) + '</p><div class="hf-cats">' + links + '</div>';
    }
    function refreshPick() { var p = body.querySelector('.hf-pick'); if (!p) return; var h = pickInner(); if (p.__h !== h) { p.innerHTML = h; p.__h = h; } }
    function resolveCat(m, c, high) {           /* erste Endung mit Produkten, sonst false */
      var chain = Promise.resolve(false);
      c.suf.forEach(function (x) { chain = chain.then(function (ok) { return ok || probe(m.u + x, high); }); });
      return chain;
    }
    function prefetch(list, high) {
      if (!cfg.check) return;
      list.forEach(function (m) { dev().cats.forEach(function (c) { resolveCat(m, c, high); }); });
    }
    var waitT = null, waited = false;
    function check() {
      if (!cfg.check || st.m < 0) return;
      var ms = models(), m = ms[st.m];
      clearTimeout(waitT); waited = false;
      Promise.all(dev().cats.map(function (c) { return resolveCat(m, c, true); }))
        .then(function () { if (models()[st.m] === m) refreshPick(); });
      prefetch(ms.slice(Math.max(0, st.m - 3), st.m + 4));
      waitT = setTimeout(function () { waited = true; if (models()[st.m] === m) refreshPick(); }, 1500);
    }
    function panelHTML(p) {
      var okUrl = function (u) { return u && u !== '#' && u !== '/' ? u : ''; };
      var cols = p.columns.map(function (c) {
        var n = c.links.length, wide = n > 10 ? 2 : 1, lc = Math.min(3, Math.ceil(n / 10));
        var u = okUrl(c.url);
        var head = (u ? '<a href="' + esc(u) + '">' + esc(c.title) + '</a>' : esc(c.title)) + badgeHTML(c.badge);
        var items = c.links.map(function (l) { return '<li><a href="' + esc(l[1]) + '">' + esc(l[0]) + badgeHTML(l[2]) + '</a></li>'; }).join('');
        var all = u && cfg.viewAll ? '<a class="hf-mp-all" href="' + esc(u) + '">' + esc(T.viewAll) + ' ›</a>' : '';
        return { span: wide, html: '<div class="hf-mp-col' + (wide > 1 ? ' hf-mp-col--wide' : '') + '" style="' + (wide > 1 ? 'grid-column:span ' + wide + ';--hf-mp-cols:' + lc : '') + '">' +
          '<p class="hf-mp-h">' + head + '</p><ul class="hf-mp-list">' + items + '</ul>' + all + '</div>' };
      });
      var nt = p.note, note = '';
      if (nt && (nt.title || nt.text || nt.img)) {
        var nu = okUrl(nt.url);
        note = '<div class="hf-mp-note">' + (nt.img ? (nu ? '<a href="' + esc(nu) + '">' : '') + '<img src="' + esc(nt.img) + '" alt="' + esc(nt.title || '') + '" loading="lazy">' + (nu ? '</a>' : '') : '') +
          (nt.title ? '<p class="hf-mp-nt">' + esc(nt.title) + '</p>' : '') + (nt.text ? '<p>' + esc(nt.text) + '</p>' : '') +
          (nu ? '<a class="hf-cat hf-cat--all" href="' + esc(nu) + '"><span>' + esc(nt.label || T.viewAll) + '</span>' + ARROW + '</a>' : '') + '</div>';
      }
      var span = cols.reduce(function (s, c) { return s + c.span; }, 0) + (note ? 1 : 0);
      return '<div class="hf-mp" style="grid-template-columns:repeat(' + span + ',minmax(0,1fr))">' + cols.map(function (c) { return c.html; }).join('') + note + '</div>';
    }
    var mode = 'finder', curPanel = null;
    var DEPTHS = ['none', 'brand', 'series', 'model'];
    function pathNow(extra) {
      var d = dev(), b = brand(), parts = [d.name, b && b.name];
      if (b && b.series && st.m > -1) parts.push(b.series[st.s].name);
      if (st.m > -1) parts.push(models()[st.m].t);
      if (extra) parts.push(extra);
      return parts.filter(Boolean).join(' › ');
    }
    function deviceCtx(extra) {
      var b = brand(), m = st.m > -1 ? models()[st.m] : null;
      return { finder_type: 'device', finder_entry: dev().name, finder_brand: b ? b.name : null, finder_model: m ? m.t : null, finder_path: pathNow(extra) };
    }
    function showPanel(pi, mobile) {
      mode = 'panel'; curPanel = pi; panel.classList.add('hf-panel--menu');
      var sb = panel.querySelector('.hf-search'); if (sb) sb.style.display = 'none';
      body.innerHTML = (mobile ? '<button type="button" class="hf-back hf-back--panel">‹ ' + esc(T.back) + '</button><p class="hf-model hf-mp-title">' + esc(PAN[pi].trigger) + '</p>' : '') + panelHTML(PAN[pi]);
      var bk = body.querySelector('.hf-back--panel');
      if (bk) bk.addEventListener('click', function () { showFinder(); st.depth = -1; render(); });
    }
    function showFinder() {
      mode = 'finder'; panel.classList.remove('hf-panel--menu');
      var sb = panel.querySelector('.hf-search'); if (sb) sb.style.display = '';
    }
    function innerFor(depth) {               /* Inhalt einer Spalte (ohne Rahmen) */
      var d = dev(), b = brand();
      var head = function (title) {
        var back = depth > 0 || (depth === 0 && multi()) ? '<button type="button" class="hf-back" data-back="' + (depth - 1) + '">‹ ' + esc(T.back) + '</button>' : '';
        return back + (title ? '<p class="hf-h">' + esc(title) + '</p>' : '');
      };
      if (depth === -1) {
        var devs = DEV.filter(function (x) { return !x.empty; }).map(function (x, i) { return row('data-d', i, i === st.d, x.name, ARROW, '', x.inner); }).join('');
        if (narrow() && !inline && PAN.length) devs += '<p class="hf-h hf-h--sub">' + esc(T.resCats) + '</p>' + PAN.map(function (p, i) { return row('data-p', i, false, p.trigger, ARROW); }).join('');
        return head(T.device) + devs;
      }
      if (depth === 0) return head(T.brand) + d.brands.map(function (x, i) {
        return x.link ? '<a class="hf-row hf-row--link" href="' + esc(x.link) + '"><span>' + esc(x.name) + badgeHTML(x.bd) + '</span>' + ARROW + '</a>' : row('data-b', i, i === st.b, x.name, ARROW, x.bd, x.inner);
      }).join('');
      if (depth === 1) return head(T.series) + (b.series ? b.series.map(function (x, i) {
        return row('data-s', i, i === st.s, x.name, cfg.counts ? '<span class="hf-n">' + x.models.length + '</span>' : ARROW, '', x.inner);
      }).join('') : '<p class="hf-hint">' + esc(T.noSeries) + '</p>');
      if (depth === 2) return head(T.model) + models().map(function (m, i) { return row('data-m', i, i === st.m, m.t, ARROW, m.bd); }).join('');
      return pickInner();
    }
    function render() {
      if (mode !== 'finder') return;
      var saved = {}; body.querySelectorAll('.hf-col').forEach(function (c) { saved[c.getAttribute('data-depth')] = c.scrollTop; });
      var d = dev(), wrap = function (depth, cls) {
        return '<div class="hf-col ' + cls + (st.depth === depth ? ' is-active' : '') + '" data-depth="' + depth + '">' + innerFor(depth) + '</div>';
      };
      body.innerHTML = '<div class="hf-cols' + (d.hasSeries ? '' : ' hf-cols--flat') + (multi() ? ' hf-cols--multi' : '') + '">' +
        (multi() ? wrap(-1, 'hf-col--dev') : '') + wrap(0, '') + (d.hasSeries ? wrap(1, '') : '') + wrap(2, '') + wrap(3, 'hf-pick') + '</div>';
      body.querySelectorAll('.hf-col').forEach(function (c) { var k = +c.getAttribute('data-depth'); if (k <= keep && saved[k]) c.scrollTop = saved[k]; });
      keep = 3; setPlaceholder(); check();
    }
    /* Auf dem Desktop nur die Spalten rechts vom gewählten Element erneuern –
       die Spalte, in der gerade gescrollt wird, bleibt dasselbe Element (kein Ruckeln). */
    function colEl(depth) { return body.querySelector('.hf-col[data-depth="' + depth + '"]'); }
    function partial(level) {
      if (narrow() || mode !== 'finder' || !colEl(2) || level === 'd') { render(); return; }
      var mark = function (depth, attr, idx) { var c = colEl(depth); if (c) c.querySelectorAll('[' + attr + ']').forEach(function (x) { x.classList.toggle('is-on', +x.getAttribute(attr) === idx); }); };
      var fill = function (depth) { var c = colEl(depth); if (c) { c.innerHTML = innerFor(depth); c.scrollTop = 0; } };
      if (level === 'b') { mark(0, 'data-b', st.b); if (colEl(1)) fill(1); fill(2); }
      if (level === 's') { mark(1, 'data-s', st.s); fill(2); }
      if (level === 'm') mark(2, 'data-m', st.m);
      var p = colEl(3); if (p) p.innerHTML = pickInner();
      check();
    }
    function match(list, toks) {
      var has = function (k, tk, t) { return k.indexOf(t) > -1 || tk.indexOf(tight(t)) > -1; };
      var out = list.filter(function (x) { return toks.every(function (t) { return has(x.key, x.tk, t); }); });
      var qt = tight(toks.join(' '));
      out.forEach(function (x, i) {            /* Treffer im eigenen Namen zählen mehr als in der Spalte */
        x._s = x.tt ? toks.reduce(function (n, t) { return n + (has(x.tt, x.ttk, t) ? 3 : 1); }, 0) : 0; x._i = i;
        x._e = (x.ttk === qt || x.tk === qt || (x.m && tight(x.m.t) === qt)) ? 1 : 0;   /* exakter Treffer: „iphone 18 pro“ vor „… Pro Max“ */
      });
      return out.sort(function (a, b) { return (b._e - a._e) || (b._s - a._s) || (a._i - b._i); });
    }
    /* ---- Produktsuche (Shopify Predictive Search) ---- */
    var prod = { q: null, items: [], loading: false }, prodT = null, prodCtl = null;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var productsOn = function () { return cfg.products === 'all' || (cfg.products === 'mobile' && narrow()); };
    var looksLikeCode = function (v) { return /^[\d\s-]{6,}$/.test(v) || (/^[a-z]{0,4}\d[\w-]{4,}$/i.test(v) && /\d{4,}/.test(v)); };
    var money = function (p) {
      var n = parseFloat(p); if (isNaN(n)) return '';
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: cur }).format(n); } catch (e) { return n.toFixed(2) + ' ' + cur; }
    };
    function fetchProducts(v) {
      clearTimeout(prodT); if (prodCtl) { try { prodCtl.abort(); } catch (e) {} prodCtl = null; }
      if (!productsOn() || v.length < 2) { prod = { q: v, items: [], loading: false }; return; }
      prod = { q: v, items: [], loading: true };
      prodT = setTimeout(function () {
        prodCtl = window.AbortController ? new AbortController() : null;
        var url = root + 'search/suggest.json?q=' + encodeURIComponent(v) +
          '&resources[type]=product&resources[limit]=' + (cfg.productLimit || 6) +
          '&resources[options][unavailable_products]=last' +
          '&resources[options][fields]=title,product_type,variants.title,vendor,tag,variants.sku,variants.barcode';
        fetch(url, { credentials: 'same-origin', signal: prodCtl ? prodCtl.signal : undefined })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            if (!q || q.value.trim() !== v) return;
            var list = (j && j.resources && j.resources.results && j.resources.results.products) || [];
            prod = { q: v, loading: false, items: list.map(function (p) {
              return { t: p.title, u: p.url, img: p.image || (p.featured_image && p.featured_image.url) || '', price: p.price, av: p.available !== false };
            }) };
            search(v, true);
          })
          .catch(function (e) { if (e && e.name === 'AbortError') return; if (q && q.value.trim() === v) { prod = { q: v, items: [], loading: false }; search(v, true); } });
      }, 250);
    }
    function thumb(src) {
      if (!src) return '<span class="hf-pimg"></span>';
      var u = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=96';
      return '<span class="hf-pimg"><img src="' + esc(u) + '" alt="" loading="lazy" width="44" height="44"></span>';
    }
    function search(v, fromProducts) {
      var vt = v.trim(), toks = skey(v).split(' ').filter(Boolean), code = looksLikeCode(vt);
      var withP = productsOn() && vt.length >= 2, pFirst = withP && cfg.order !== 'models';
      var hits = code ? [] : match(flat, toks);
      hits.sort(function (a, b) { return (a.d !== st.d) - (b.d !== st.d); });
      hits = hits.slice(0, pFirst ? 5 : 20);                      /* Produkte zuerst → Modelle/Kategorien nur als Ergänzung */
      var ch = code ? [] : match(cats, toks).slice(0, pFirst ? 5 : 12);
      if (!fromProducts) fetchProducts(vt);
      var pi = prod.q === vt ? prod : { items: [], loading: withP };
      var direct = !narrow() && cfg.searchDirect;
      var heads = (hits.length ? 1 : 0) + (ch.length ? 1 : 0) + (withP && (pi.loading || pi.items.length) ? 1 : 0) > 1;
      var mHTML = hits.length ? (heads ? '<p class="hf-rh">' + esc(T.resModels) + '</p>' : '') + hits.map(function (h) {
        var inner = '<span><b>' + esc(h.m.t) + '</b>' + badgeHTML(h.m.bd) + '<small>' + esc(h.label) + '</small></span>' + ARROW;
        return direct ? '<a class="hf-res hf-res--link" href="' + esc(h.m.u) + '">' + inner + '</a>'
                      : '<button type="button" class="hf-res" data-r="' + flat.indexOf(h) + '">' + inner + '</button>';
      }).join('') : '';
      var cHTML = ch.length ? (heads ? '<p class="hf-rh">' + esc(T.resCats) + '</p>' : '') + ch.map(function (c) {
        return '<a class="hf-res hf-res--link" href="' + esc(c.url) + '"><span><b>' + esc(c.title) + '</b>' + badgeHTML(c.bd) + '<small>' + esc(c.label) + '</small></span>' + ARROW + '</a>';
      }).join('') : '';
      var pHTML = '';
      if (withP && (pi.loading || pi.items.length)) {
        pHTML = (heads ? '<p class="hf-rh">' + esc(T.resProducts) + '</p>' : '') + (pi.loading && !pi.items.length
          ? Array(pFirst ? 4 : 3).join('<span class="hf-res hf-res--skel"><span class="hf-pimg"></span><span class="hf-skel"></span></span>')
          : pi.items.map(function (p) {
              return '<a class="hf-res hf-res--link hf-res--prod' + (p.av ? '' : ' is-soldout') + '" href="' + esc(p.u) + '">' + thumb(p.img) +
                '<span><b>' + esc(p.t) + '</b><small>' + esc(money(p.price)) + '</small></span>' + ARROW + '</a>';
            }).join(''));
      }
      /* Reihenfolge laut Einstellung: Produkte → Modelle → Kategorien (Standard) oder Modelle → Kategorien → Produkte */
      var html = pFirst ? pHTML + mHTML + cHTML : mHTML + cHTML + pHTML;
      if (withP) html += '<a class="hf-res hf-res--link hf-res--all" href="' + esc(root + 'search?q=' + encodeURIComponent(vt) + '&type=product') + '"><span><b>' + esc(T.allResults) + ' „' + esc(vt) + '“</b></span>' + ARROW + '</a>';
      var noHits = !hits.length && !ch.length && !pi.items.length && !pi.loading;
      body.innerHTML = '<div class="hf-results">' + (noHits ? '<p class="hf-hint hf-empty">' + esc(T.noResults) + '</p>' : '') + html + '</div>';
      lastSearch = { term: vt, n: hits.length + ch.length + pi.items.length };
      if (fromProducts) return;
      clearTimeout(searchT);
      searchT = setTimeout(function () {                  /* erst senden, wenn der Kunde 1 s nicht mehr tippt */
        if (!lastSearch || lastSearch.term.length < 2 || lastSearch.term === sentTerm) return;
        sentTerm = lastSearch.term;
        track(lastSearch.n ? 'finder_search' : 'finder_search_no_results', { finder_type: 'search', finder_entry: dev().name, search_term: lastSearch.term, results_count: lastSearch.n });
      }, 1000);
    }
    var lastSearch = null, searchT = null, sentTerm = null;
    function selectDevice(i) { st.d = i; st.b = firstBrand(); st.s = 0; st.m = -1; setPlaceholder(); if (!dev().empty) prefetch(models().slice(0, 8)); }
    function pick(el) {
      var a = function (n) { return +el.getAttribute(n); };
      if (el.hasAttribute('data-d')) { keep = -1; selectDevice(a('data-d')); st.depth = 0; return 'd'; }
      else if (el.hasAttribute('data-b')) { if (sess) sess.maxDepth = Math.max(sess.maxDepth, 1); keep = 0; st.b = a('data-b'); st.s = 0; st.m = -1; st.depth = brand().series ? 1 : 2; prefetch(models().slice(0, 14)); return 'b'; }
      else if (el.hasAttribute('data-s')) { if (sess) sess.maxDepth = Math.max(sess.maxDepth, 2); keep = 1; st.s = a('data-s'); st.m = -1; st.depth = 2; prefetch(models().slice(0, 14)); return 's'; }
      else if (el.hasAttribute('data-m')) { if (sess) sess.maxDepth = 3; keep = 2; st.m = a('data-m'); st.depth = 3; return 'm'; }
      else return false;
      return true;
    }
    body.addEventListener('click', function (e) {
      var a = e.target.closest('a'), r0 = e.target.closest('[data-r]');
      if (a || r0) {
        if (sess) sess.clicked = true;
        var txt = a ? (a.querySelector('b') || a.querySelector('span') || a).textContent.trim() : '';
        if (a && a.classList.contains('hf-res--link') || r0) {
          var term = q ? q.value.trim() : '';
          track('finder_search_click', { finder_type: 'search', finder_entry: dev().name, search_term: term, finder_category: r0 ? null : txt,
            finder_model: r0 ? flat[+r0.getAttribute('data-r')].m.t : null, link_url: a ? a.getAttribute('href') : null });
        } else if (a && a.classList.contains('hf-cat') && mode === 'finder') {
          var cat = a.classList.contains('hf-cat--all') ? 'Alles' : txt, c1 = deviceCtx(cat);
          c1.finder_category = cat; c1.link_url = a.getAttribute('href'); c1.depth_reached = 'category';
          track('finder_category_click', c1);
        } else if (a && a.classList.contains('hf-row--link')) {
          var c2 = deviceCtx(txt); c2.finder_category = txt; c2.link_url = a.getAttribute('href'); track('finder_category_click', c2);
        } else if (a && mode === 'panel') {
          var colEl = a.closest('.hf-mp-col'), colT = colEl ? colEl.querySelector('.hf-mp-h').textContent.trim() : (a.closest('.hf-mp-note') ? 'Box' : '');
          var pn = curPanel != null ? PAN[curPanel].trigger : '';
          track('finder_panel_click', { finder_type: 'panel', finder_entry: pn, finder_category: txt, finder_path: [pn, colT, txt].filter(Boolean).join(' › '), link_url: a.getAttribute('href') });
        }
      }
      var back = e.target.closest('[data-back]');
      if (back) { st.depth = +back.getAttribute('data-back'); if (st.depth === 1 && !brand().series) st.depth = 0; render(); return; }
      var r = e.target.closest('[data-r]');
      if (r) { var h = flat[+r.getAttribute('data-r')]; st.d = h.d; st.b = h.b; st.s = h.s; st.m = h.mi; st.depth = 3; setPlaceholder(); if (q) q.value = ''; render(); return; }
      var pp = e.target.closest('[data-p]');
      if (pp) { showPanel(+pp.getAttribute('data-p'), true); return; }
      var el = e.target.closest('button.hf-row'), lv = el && pick(el); if (lv) partial(lv);
    });
    /* Auswahl per Maus: nur bei echter Mausbewegung, nicht während/kurz nach dem Scrollen
       (beim Scrollen wandert die Liste unter dem stehenden Cursor – das ist keine Auswahl). */
    var hoverT = null, hoverRow = null, lastScroll = 0, SCROLL_PAUSE = 250;
    var stopHover = function () { clearTimeout(hoverT); hoverT = null; };
    body.addEventListener('wheel', function () { lastScroll = Date.now(); stopHover(); }, { passive: true });
    body.addEventListener('scroll', function () { lastScroll = Date.now(); stopHover(); }, true);
    body.addEventListener('mousemove', function (e) {
      if (narrow() || !cfg.hoverSelect || mode !== 'finder') return;
      var el = e.target.closest('button.hf-row');
      if (el === hoverRow && hoverT) return;
      hoverRow = el; stopHover();
      if (!el || el.classList.contains('is-on') || Date.now() - lastScroll < SCROLL_PAUSE) return;
      if (el.hasAttribute('data-s')) { var sr = brand().series && brand().series[+el.getAttribute('data-s')]; if (sr) prefetch(sr.models.slice(0, 14)); }
      if (el.hasAttribute('data-m')) { var mm = models()[+el.getAttribute('data-m')]; if (mm) prefetch([mm], true); }
      hoverT = setTimeout(function () { hoverT = null; if (!el.isConnected) return; var lv = pick(el); if (lv) partial(lv); }, 70);
    });
    body.addEventListener('mouseleave', function () { stopHover(); hoverRow = null; });
    if (q) {
      q.addEventListener('input', function () { var v = q.value.trim(); if (v) search(v); else { fetchProducts(''); render(); } });
      q.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        var first = body.querySelector('.hf-res:not(.hf-res--skel)'), all = body.querySelector('.hf-res--all');
        var target = first && first.classList.contains('hf-res--prod') && all ? all : first;   /* nur Produkte → alle Ergebnisse */
        if (!target && all) target = all;
        if (target) { e.preventDefault(); target.click(); }
      });
    }
    if (!DEV[0].empty) { selectDevice(0); st.depth = multi() ? -1 : 0; render(); }
    if (inline) return;
    /* Vom Header (snippets/hf-header-search.liquid) direkt gerendertes Suchfeld → kein Austausch, kein Aufblitzen */
    var ssrBar = document.querySelector('.hf-mbar--ssr');
    if (ssrBar) { var ownBar = host.querySelector('.hf-mbar'); if (ownBar) ownBar.remove(); }
    var mroot = ssrBar || host;

    /* ---- Menü-Modus ----
       Zonen: Panel | Brücke (Menüleiste + Spalt über dem Panel) | Finder-Menüpunkt | anderer Menüpunkt | außerhalb
       - Panel/Brücke: bleibt offen
       - anderer Menüpunkt: schließt sofort (dessen eigenes Menü übernimmt)
       - außerhalb: schließt nach CLOSE_MS
       - anderer Finder-Menüpunkt: wechselt erst, wenn die Maus dort SWITCH_MS ruht (schräges Durchfahren wechselt nicht) */
    var OPEN_MS = 90, SWITCH_MS = 180, FAST_MS = 40, CLOSE_MS = 350;
    var isOpen = false, openT = null, closeT = null, pendingT = null, pendingFast = false, current = null, attached = [];
    var clear = function (t) { if (t) clearTimeout(t); return null; };
    var barOf = function (t) { return t.a.closest('nav') || t.li.parentElement || t.li; };
    var inR = function (r, x, y) { return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom; };
    function position() {
      if (!current || narrow()) return;
      panel.style.top = Math.max(0, barOf(current).getBoundingClientRect().bottom) + 'px';
    }
    function startSess(source) {
      endSess('switch');
      var entry = current && current.pi != null ? PAN[current.pi].trigger : (current ? DEV[current.di].name : null);
      sess = { t0: Date.now(), clicked: false, sent: false, maxDepth: 0, type: current && current.pi != null ? 'panel' : 'device', entry: entry };
      var send = function () { if (!sess || sess.sent) return; sess.sent = true; track('finder_open', { finder_type: sess.type, finder_entry: sess.entry || 'mobile', open_source: source }); };
      if (source === 'mobile') send(); else sess.timer = setTimeout(send, 600);   /* zufälliges Überfahren zählt nicht */
    }
    function endSess(why) {
      if (!sess) return; clearTimeout(sess.timer);
      if (sess.sent && !sess.clicked) {
        var ctx = sess.type === 'device' ? deviceCtx() : { finder_type: 'panel', finder_entry: sess.entry };
        ctx.depth_reached = DEPTHS[sess.maxDepth]; ctx.duration_ms = Date.now() - sess.t0;
        ctx.close_reason = why === 'switch' ? 'switch' : 'close';
        track('finder_close', ctx);
      }
      sess = null;
    }
    function setOpen(o, trg) {
      openT = clear(openT); closeT = clear(closeT); pendingT = null;
      if (!o) endSess();
      isOpen = o; panel.classList.toggle('is-open', o);
      attached.forEach(function (t) { t.a.setAttribute('aria-expanded', o && t === trg ? 'true' : 'false'); });
      if (o) {
        if (trg && trg.pi != null) { if (trg !== current || mode !== 'panel') { current = trg; showPanel(trg.pi); } }
        else if (trg && (trg !== current || mode !== 'finder')) { current = trg; showFinder(); selectDevice(trg.di); st.depth = 0; if (q) q.value = ''; render(); }
        else if (!trg && narrow() && !DEV[0].empty) { current = null; showFinder(); st.depth = multi() ? -1 : 0; if (q) q.value = ''; render(); }
        position(); if (narrow()) document.documentElement.classList.add('hf-lock');
        if (!sess || (trg && sess.entry !== (trg.pi != null ? PAN[trg.pi].trigger : DEV[trg.di].name))) startSess(trg ? 'hover' : 'mobile');
      } else document.documentElement.classList.remove('hf-lock');
    }
    /* Was liegt WIRKLICH unter dem Cursor? (elementFromPoint statt nur Koordinaten)
       So zählt z. B. die Suchvorschau des Themes, die über der Menüleiste liegt, nicht als Menüpunkt. */
    function zone(x, y) {
      var box = panel.querySelector('.hf-in'), el = document.elementFromPoint(x, y);
      if (!el) return 'out';
      if (isOpen && box.contains(el)) return 'panel';
      for (var i = 0; i < attached.length; i++) if (attached[i].li.contains(el)) return attached[i];
      if (isOpen && current) {
        var bar = barOf(current), br = bar.getBoundingClientRect(), pr = box.getBoundingClientRect();
        if (y >= br.top && y <= pr.top + 1 && x >= Math.min(br.left, pr.left) && x <= Math.max(br.right, pr.right)) {
          if (!bar.contains(el) && !panel.contains(el)) return 'out';          /* etwas anderes liegt darüber */
          var li = el.closest && el.closest('li');
          if (li && bar.contains(li) && y <= br.bottom && !attached.some(function (t) { return t.li === li || t.li.contains(li); })) return 'other';
          return 'bridge';
        }
      }
      return 'out';
    }
    var px = null, py = null;
    function onMove(x, y) {
      if (narrow()) return;
      var dx = px === null ? 0 : x - px, dy = py === null ? 0 : y - py; px = x; py = y;
      var z = zone(x, y);
      if (z === 'panel' || z === 'bridge') { closeT = clear(closeT); openT = clear(openT); pendingT = null; return; }
      if (z === 'other') { openT = clear(openT); pendingT = null; if (isOpen) setOpen(false); return; }
      if (z === 'out') { openT = clear(openT); pendingT = null; if (isOpen && !closeT) closeT = setTimeout(function () { setOpen(false); }, CLOSE_MS); return; }
      closeT = clear(closeT);
      if (isOpen && current === z) { openT = clear(openT); pendingT = null; return; }
      /* Waagerecht an der Leiste entlang = gewollter Wechsel → schnell.
         Nach unten (Richtung Panel) = evtl. nur Durchfahren → erst wechseln, wenn die Maus ruht. */
      var along = !isOpen || dy <= 2;
      if (along && pendingT === z && openT && pendingFast) return;
      openT = clear(openT); pendingT = z; pendingFast = along;
      openT = setTimeout(function () { setOpen(true, z); }, !isOpen ? OPEN_MS : along ? FAST_MS : SWITCH_MS);
    }
    function attach() {
      if (narrow()) return;
      var list = DEV.filter(function (d) { return !d.empty; }).map(function (d, di) { return { key: 'd' + di, title: d.trigger || d.name, di: di }; })
        .concat(PAN.map(function (p, pi) { return { key: 'p' + pi, title: p.trigger, pi: pi, badge: p.badge }; }));
      list.forEach(function (it) {
        if (attached.some(function (t) { return t.key === it.key; })) return;
        var a = findLink(it.title, attached.map(function (t) { return t.a; })); if (!a) return;
        var li = a.closest('li') || a.parentElement, t = { a: a, li: li, di: it.di, pi: it.pi, key: it.key };
        a.classList.add('hf-trg'); li.classList.add('hf-navli'); if (li.parentElement) li.parentElement.classList.add('hf-navlist');
        if (it.badge && !a.querySelector('.hf-badge')) {
          var bd = document.createElement('span'); bd.className = 'hf-badge'; bd.textContent = it.badge;
          var bc = BCOL[String(it.badge).toLowerCase()]; if (bc) { bd.style.background = bc[0]; bd.style.color = bc[1]; }
          a.appendChild(bd);
        }
        attached.push(t);
        if (cfg.hideNative && li) [].forEach.call(li.children, function (c) { if (!c.contains(a)) c.classList.add('hf-native-hidden'); });
        a.setAttribute('aria-haspopup', 'true'); a.setAttribute('aria-expanded', 'false');
        a.addEventListener('click', function (e) { if (cfg.clickOpens && !narrow()) { e.preventDefault(); setOpen(!(isOpen && current === t), t); } });
        a.addEventListener('focus', function () { if (!narrow()) setOpen(true, t); });
      });
    }
    function findLink(title, taken) {
      var want = norm(title); if (!want) return null;
      var all = document.querySelectorAll('a, button, summary');
      for (var i = 0; i < all.length; i++) {
        var a = all[i];
        if (panel.contains(a) || host.contains(a) || taken.indexOf(a) > -1) continue;
        if (norm(a.textContent) === want && a.offsetParent !== null) return a;
      }
      return null;
    }
    var raf = 0, lx = 0, ly = 0;
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch') return;
      lx = e.clientX; ly = e.clientY;
      if (!raf) raf = requestAnimationFrame(function () { raf = 0; onMove(lx, ly); });
    }, { passive: true });
    document.documentElement.addEventListener('mouseleave', function () {
      openT = clear(openT); pendingT = null;
      if (isOpen && !narrow() && !closeT) closeT = setTimeout(function () { setOpen(false); }, CLOSE_MS);
    });
    var HINT = 'hf-hint-seen', hintClosed = false;
    var hint = host.querySelector('[data-hf-hint]');
    var hideHint = function () {
      hintClosed = true; if (hint) hint.hidden = true;
      if (storageAllowed()) { try { localStorage.setItem(HINT, '1'); } catch (e) {} }
    };
    function updateHint() {           /* ohne Speicher-Erlaubnis: Hinweis nur auf der Startseite zeigen */
      if (!hint || hintClosed) return;
      var seen = false;
      if (storageAllowed()) { try { seen = localStorage.getItem(HINT) === '1'; } catch (e) {} }
      else seen = hint.getAttribute('data-home') !== 'true';
      hint.hidden = seen;
    }
    initConsent(function () { loadCache(); updateHint(); saveCache(); });   /* erst entscheiden, wenn der Consent-Status bekannt ist */
    (function rotateLabel() {
      var span = mroot.querySelector('.hf-mbtn span');
      var lines = String(cfg.mobileLabels || '').split(/\n/).map(function (x) { return x.trim(); }).filter(Boolean);
      var first = lines[0] || cfg.mobileLabel;
      if (span && first && span.textContent.trim() !== first) span.textContent = first;   /* Text aus den Sektionseinstellungen */
      if (!span || lines.length < 2) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var i = 0;
      setInterval(function () {
        if (isOpen || document.hidden || !narrow()) return;
        span.classList.add('is-fade');
        setTimeout(function () { i = (i + 1) % lines.length; span.textContent = lines[i]; span.classList.remove('is-fade'); }, 260);
      }, 3200);
    })();
    host.querySelectorAll('[data-hf-hint-x]').forEach(function (x) { x.addEventListener('click', function (e) { e.stopPropagation(); hideHint(); }); });
    mroot.querySelectorAll('[data-hf-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { hideHint(); setOpen(true); if (q && cfg.focusSearch) q.focus(); });
    });
    panel.querySelector('.hf-x').addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) setOpen(false); });
    document.addEventListener('click', function (e) {
      if (!isOpen || narrow() || !e.target.isConnected || panel.contains(e.target)) return;
      if (attached.some(function (t) { return t.li.contains(e.target); })) return;
      setOpen(false);
    });
    /* Telefon: unser Suchfeld an die Stelle der Theme-Suche setzen – das Header-Layout des Themes bleibt unverändert. */
    (function placeInTheme() {
      if (ssrBar || cfg.themeSearch !== 'replace' || !cfg.themeSel) return;
      var bar = host.querySelector('.hf-mbar'), slot = null;
      try { slot = document.querySelector(cfg.themeSel); } catch (e) {}
      if (!bar) return;
      if (!slot) { host.classList.add('hf-noslot'); return; }   /* Theme-Suche nicht gefunden → Feld bleibt unter dem Header */
      bar.classList.add('hf-mbar--in-theme');
      slot.classList.add('hf-theme-slot');
      slot.appendChild(bar);
    })();
    /* ---- Komputer: Suchfeld im Header (snippets/hf-header-search.liquid) mit Ergebnis-Panel ---- */
    (function desktopSearch() {
      var form = document.querySelector('[data-hf-dsearch]');
      if (!form || !cfg.desktopSearch || form.__hf) return; form.__hf = true;
      var inp = form.querySelector('.hf-dsearch__input'), dd = form.querySelector('.hf-dd');
      if (!inp || !dd) return;
      if (cfg.desktopPlaceholder && inp.placeholder !== cfg.desktopPlaceholder) { inp.placeholder = cfg.desktopPlaceholder; inp.setAttribute('aria-label', cfg.desktopPlaceholder); }
      var LIM = Math.min(cfg.desktopProducts || 10, 10), P = { q: null, items: [], loading: false }, pT = null, pCtl = null;
      var act = -1, lastN = 0, sentQ = null, sT = null, watch = {}, redrawT = null;
      function redrawSoon(vt) {                  /* Antworten bündeln: höchstens ein Neuzeichnen pro 80 ms */
        clearTimeout(redrawT); redrawT = setTimeout(function () { if (inp.value.trim() === vt) draw(vt); }, 80);
      }
      function hl(text, toks) {                   /* eingegebene Teile im Namen hervorheben */
        var s = String(text || ''), low = s.toLowerCase(), mk = [];
        toks.forEach(function (t) { if (!t) return; var i = 0; while ((i = low.indexOf(t, i)) > -1) { for (var j = i; j < i + t.length; j++) mk[j] = 1; i += t.length; } });
        var out = '', on = false;
        for (var k = 0; k < s.length; k++) { if (!!mk[k] !== on) { out += on ? '</mark>' : '<mark>'; on = !on; } out += esc(s[k]); }
        return out + (on ? '</mark>' : '');
      }
      function img(src) {
        if (!src) return '<span class="hf-dd__img"></span>';
        var u = /[?&]width=/.test(src) ? src : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        return '<span class="hf-dd__img"><img src="' + esc(u) + '" alt="" loading="lazy" width="48" height="48"></span>';
      }
      function fetchP(v) {
        clearTimeout(pT); if (pCtl) { try { pCtl.abort(); } catch (e) {} pCtl = null; }
        if (v.length < 2) { P = { q: v, items: [], loading: false }; return; }
        P = { q: v, items: [], loading: true };
        pT = setTimeout(function () {
          pCtl = window.AbortController ? new AbortController() : null;
          fetch(root + 'search/suggest.json?q=' + encodeURIComponent(v) + '&resources[type]=product&resources[limit]=' + LIM +
            '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag,variants.sku,variants.barcode',
            { credentials: 'same-origin', signal: pCtl ? pCtl.signal : undefined })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (j) {
              if (inp.value.trim() !== v) return;
              var list = (j && j.resources && j.resources.results && j.resources.results.products) || [];
              P = { q: v, loading: false, items: list.map(function (p) {
                return { t: p.title, u: p.url, img: p.image || (p.featured_image && p.featured_image.url) || '', price: p.price, av: p.available !== false };
              }) };
              draw(v);
            })
            .catch(function (e) { if (e && e.name === 'AbortError') return; if (inp.value.trim() === v) { P = { q: v, items: [], loading: false }; draw(v); } });
        }, 200);
      }
      function chips(h, vt) {                     /* Kategorien direkt am Modell – nur solche mit Produkten */
        var d = DEV[h.d]; if (!d || !d.cats || !d.cats.length) return '';
        var out = '', wait = false;
        d.cats.forEach(function (c) {
          var u = catUrl(h.m, c);
          if (u === false) return;
          if (u === null) { wait = true; out += '<span class="hf-dd__chip hf-dd__chip--sk"></span>'; return; }
          out += '<a class="hf-dd__chip" href="' + esc(u) + '" data-hf-k="chip" data-hf-mt="' + esc(h.m.t) + '">' + esc(c.name) + '</a>';
        });
        if (wait) d.cats.forEach(function (c) {
          if (catUrl(h.m, c) !== null) return;
          var key = h.m.u + '|' + c.name; if (watch[key]) return; watch[key] = 1;   /* jede Kategorie nur einmal prüfen */
          resolveCat(h.m, c, true).then(function () { delete watch[key]; redrawSoon(vt); });
        });
        return out ? '<div class="hf-dd__chips">' + out + '</div>' : '';
      }
      function items() { return [].slice.call(dd.querySelectorAll('a.hf-dd__it, a.hf-dd__chip, a.hf-dd__all')); }
      function mark(scroll) {
        items().forEach(function (a, i) { a.classList.toggle('is-act', i === act); if (i === act && scroll) a.scrollIntoView({ block: 'nearest' }); });
      }
      function open() {
        if (dd.hidden) { dd.hidden = false; form.classList.add('is-open'); inp.setAttribute('aria-expanded', 'true'); }
        dd.style.left = '0px';
        var r = dd.getBoundingClientRect(), vw = document.documentElement.clientWidth;
        if (r.right > vw - 16) dd.style.left = Math.round(vw - 16 - r.right) + 'px';
      }
      function close() { if (!dd.hidden) { dd.hidden = true; form.classList.remove('is-open'); inp.setAttribute('aria-expanded', 'false'); } act = -1; }
      function draw(v) {
        var vt = String(v || '').trim();
        if (!vt) { close(); dd.innerHTML = ''; return; }
        var toks = skey(vt).split(' ').filter(Boolean), code = looksLikeCode(vt);
        var hits = code ? [] : match(flat, toks).slice(0, 6), ch = code ? [] : match(cats, toks).slice(0, 6);
        if (P.q !== vt) fetchP(vt);
        var pi = P.q === vt ? P : { items: [], loading: vt.length >= 2 };
        var left = '', right = '';
        if (hits.length) left += '<p class="hf-dd__h">' + esc(T.resModels) + '</p>' + hits.map(function (h, i) {
          return '<a class="hf-dd__it" href="' + esc(h.m.u) + '" data-hf-k="model" data-hf-mt="' + esc(h.m.t) + '"><span class="hf-dd__tx"><b>' + hl(h.m.t, toks) + badgeHTML(h.m.bd) +
            '</b><small>' + esc(h.label) + '</small></span>' + ARROW + '</a>' + (i < 2 ? chips(h, vt) : '');
        }).join('');
        if (ch.length) left += '<p class="hf-dd__h">' + esc(T.resCats) + '</p>' + ch.map(function (c) {
          return '<a class="hf-dd__it" href="' + esc(c.url) + '" data-hf-k="category"><span class="hf-dd__tx"><b>' + hl(c.title, toks) + badgeHTML(c.bd) +
            '</b><small>' + esc(c.label) + '</small></span>' + ARROW + '</a>';
        }).join('');
        if (pi.loading && !pi.items.length) right = '<p class="hf-dd__h">' + esc(T.resProducts) + '</p>' +
          Array(5).join('<span class="hf-dd__it hf-dd__it--sk"><span class="hf-dd__img"></span><span class="hf-dd__tx"><i></i><i></i></span></span>');
        else if (pi.items.length) right = '<p class="hf-dd__h">' + esc(T.resProducts) + '</p>' + pi.items.map(function (p) {
          return '<a class="hf-dd__it hf-dd__it--prod' + (p.av ? '' : ' is-soldout') + '" href="' + esc(p.u) + '" data-hf-k="product">' + img(p.img) +
            '<span class="hf-dd__tx"><b>' + hl(p.t, toks) + '</b><small><span class="hf-dd__price">' + esc(money(p.price)) + '</span>' +
            (p.av ? '' : ' · ' + esc(T.soldOut || 'Ausverkauft')) + '</small></span></a>';
        }).join('');
        var colL = left ? '<div class="hf-dd__col">' + left + '</div>' : '', colP = right ? '<div class="hf-dd__col hf-dd__col--p">' + right + '</div>' : '';
        var pLeft = cfg.desktopLayout !== 'products_right';
        var grid = !left && !right ? '<p class="hf-dd__empty">' + esc(T.noResults) + '</p>'
          : '<div class="hf-dd__grid' + (left && right ? (pLeft ? ' hf-dd__grid--pl' : '') : ' hf-dd__grid--one') + '">' + (pLeft ? colP + colL : colL + colP) + '</div>';
        var keepAct = act, keepCols = [].map.call(dd.querySelectorAll('.hf-dd__col'), function (c) { return c.scrollTop; });
        dd.innerHTML = grid + '<a class="hf-dd__all" href="' + esc(root + 'search?q=' + encodeURIComponent(vt) + '&type=product') + '" data-hf-k="all"><span>' +
          esc(T.allResults) + ' „' + esc(vt) + '“</span>' + ARROW + '</a>';
        dd.querySelectorAll('.hf-dd__col').forEach(function (c, i) { if (keepCols[i]) c.scrollTop = keepCols[i]; });
        lastN = hits.length + ch.length + pi.items.length;
        act = keepAct < items().length ? keepAct : -1;
        if (document.activeElement === inp) open();
        mark(false);
      }
      function sendSearch() {
        clearTimeout(sT);
        sT = setTimeout(function () {             /* erst senden, wenn 1 s nicht mehr getippt wird */
          var v = inp.value.trim(); if (v.length < 2 || v === sentQ) return; sentQ = v;
          track(lastN ? 'finder_search' : 'finder_search_no_results', { finder_type: 'search', finder_entry: 'Header', search_term: v, results_count: lastN, open_source: 'desktop' });
        }, 1000);
      }
      inp.addEventListener('input', function () { act = -1; draw(inp.value); sendSearch(); });
      inp.addEventListener('focus', function () { if (inp.value.trim()) draw(inp.value); });
      inp.addEventListener('keydown', function (e) {
        var list = items();
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          if (dd.hidden) { if (inp.value.trim()) draw(inp.value); return; }
          if (!list.length) return;
          e.preventDefault();
          act = e.key === 'ArrowDown' ? (act + 1) % list.length : (act <= 0 ? list.length - 1 : act - 1);
          mark(true);
        } else if (e.key === 'Escape') {
          if (!dd.hidden) { e.preventDefault(); close(); } else if (inp.value) { inp.value = ''; draw(''); }
        } else if (e.key === 'Enter') {
          var v = inp.value.trim();
          if (act > -1 && list[act]) { e.preventDefault(); list[act].click(); return; }
          if (!v) { e.preventDefault(); return; }
          if (looksLikeCode(v) && P.q === v && P.items.length === 1) { e.preventDefault(); var only = dd.querySelector('a[data-hf-k="product"]'); if (only) { only.click(); return; } }
          track('finder_search_click', { finder_type: 'search', finder_entry: 'Header', search_term: v, finder_category: 'Enter', link_url: root + 'search?q=' + encodeURIComponent(v) + '&type=product', open_source: 'desktop' });
        }
      });
      form.addEventListener('submit', function (e) { if (!inp.value.trim()) e.preventDefault(); });
      dd.addEventListener('mousemove', function (e) {
        var a = e.target.closest('a.hf-dd__it, a.hf-dd__chip, a.hf-dd__all'); if (!a) return;
        var i = items().indexOf(a); if (i !== act) { act = i; mark(false); }
      });
      dd.addEventListener('mousedown', function (e) { if (e.target.closest('a')) e.preventDefault(); });   /* Fokus bleibt im Feld */
      dd.addEventListener('click', function (e) {
        var a = e.target.closest('a[data-hf-k]'); if (!a) return;
        var k = a.getAttribute('data-hf-k'), b = a.querySelector('b');
        track('finder_search_click', { finder_type: 'search', finder_entry: 'Header', search_term: inp.value.trim(), open_source: 'desktop',
          finder_model: a.getAttribute('data-hf-mt') || null,
          finder_category: k === 'chip' ? a.textContent.trim() : k === 'category' ? (b ? b.textContent.trim() : null) : k === 'product' ? 'Produkt' : k === 'all' ? 'Alle Ergebnisse' : null,
          link_url: a.getAttribute('href') });
      });
      document.addEventListener('mousedown', function (e) { if (!form.contains(e.target)) close(); });
      form.addEventListener('focusout', function (e) { if (!e.relatedTarget || !form.contains(e.relatedTarget)) setTimeout(function () { if (!form.contains(document.activeElement)) close(); }, 0); });
      window.addEventListener('resize', function () { if (!dd.hidden) open(); });
    })();
    window.addEventListener('scroll', function () { if (isOpen) position(); }, { passive: true });
    window.addEventListener('resize', function () { attach(); if (isOpen) position(); });
    attach();
    host.__hfDestroy = function () { panel.remove(); };
  }

  function boot() { document.querySelectorAll('.hf-section').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var h = e.target.querySelector('.hf-section'); if (h) init(h); });
  document.addEventListener('shopify:section:unload', function (e) { var h = e.target.querySelector('.hf-section'); if (h && h.__hfDestroy) h.__hfDestroy(); });
})();


  } catch(e) { console.error(e); }
})();
})();
